// Pure tag-convention logic. NO browser/Vite imports → unit-testable in node.
// Multi-agent convention (AGENT.md §7): every ticket carries proj:<name> and
// actor:<name>; NO spaces anywhere in a tag (repo.py matches with LIKE).

export interface ParsedTags {
  project: string | null;
  actor: string | null;
  labels: string[];
}

const PROJ = "proj:";
const ACTOR = "actor:";

// The fallback "unassigned" bucket. Tickets created without a chosen project
// land here; dissolving a project reassigns its tickets here. Kept as an ASCII
// slug to satisfy the multi-agent proj: convention; humans see it as 未分類.
export const INBOX_SLUG = "inbox";

export function parseTags(tags: string[]): ParsedTags {
  let project: string | null = null;
  let actor: string | null = null;
  const labels: string[] = [];
  for (const raw of tags) {
    const t = raw.trim();
    if (!t) continue;
    if (t.startsWith(PROJ)) {
      if (project === null) project = t.slice(PROJ.length);
    } else if (t.startsWith(ACTOR)) {
      if (actor === null) actor = t.slice(ACTOR.length);
    } else {
      labels.push(t);
    }
  }
  return { project, actor, labels };
}

export function composeTags(input: ParsedTags): string[] {
  const out: string[] = [];
  // Strip ALL whitespace from the composed tag — the convention forbids spaces
  // anywhere because repo.py queries with LIKE '%...%'.
  if (input.project) out.push(`${PROJ}${input.project}`.replace(/\s+/g, ""));
  if (input.actor) out.push(`${ACTOR}${input.actor}`.replace(/\s+/g, ""));
  for (const l of input.labels) {
    const clean = l.trim();
    if (clean) out.push(clean);
  }
  return out;
}

// Avatar label for the actor byline. The human operator shows as "EO".
export function actorDisplay(actor: string | null): string {
  if (!actor) return "—";
  if (actor === "human") return "EO";
  return actor;
}

// Human-facing project name. The inbox slug renders as 未分類; every other
// project shows its slug verbatim.
export function projectDisplay(slug: string): string {
  if (slug === INBOX_SLUG) return "未分類";
  return slug;
}
